import UsuariosCV from "./controladorVista/usuariosCV"

export const Usuarios = () => {
    return <UsuariosCV />;
}
